import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-investigation-docs',
  templateUrl: './investigation-docs.component.html',
  styleUrls: ['./investigation-docs.component.css']
})
export class InvestigationDocsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/investigation-docs/investigation-docs.component.ts